import { ButtonAlert } from 'components/ButtonAlert';
import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { ErrorHandlingModal } from 'components/ErrorHandlingModal';
import { RequestStatus } from 'features/request/requestSlice';
import { WorkOrderStatusEnum } from 'gql/graphql';
import { cnMixSpace } from 'uikit';

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useWorkOrderOtherDelete } from './useWorkOrderOtherDelete';

interface IProjectDeleteProps {
    workOrderPriceIds?: number[];
    onSuccess?: () => void;
    workOrderStatus?: WorkOrderStatusEnum;
}

export const WorkOrderOtherDelete = ({ workOrderPriceIds, onSuccess, workOrderStatus }: IProjectDeleteProps) => {
    const dispatch = useDispatch();

    const isActOther = workOrderStatus === WorkOrderStatusEnum.InProgress;

    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);

    const variables = useMemo(() => ({ workOrderOtherPriceIds: workOrderPriceIds }), [workOrderPriceIds]);

    const {
        isSubmitted,
        deleteData,
        deleteStatus,
        deleteError,
        deleteActionCreator,
        resetRemovedData,
        handleCloseModalError,
        handleCreateReport,
    } = useWorkOrderOtherDelete({
        isActOther,
    });

    const handleDeleteExactly = useCallback(() => {
        dispatch(deleteActionCreator(variables));
    }, [deleteActionCreator, dispatch, variables]);

    const handleDeleteBtn = useCallback(() => {
        setIsConfirmationDialogOpen(true);
    }, []);

    const handleOnClose = useCallback(() => {
        setIsConfirmationDialogOpen(false);
    }, []);

    useEffect(() => {
        if (deleteData?.data?.length && deleteData?.result) {
            resetRemovedData(null);
            onSuccess?.();
        }
    }, [deleteData, onSuccess, resetRemovedData, workOrderPriceIds]);

    return (
        <>
            <ButtonAlert
                label="Удалить"
                size="xs"
                onClick={handleDeleteBtn}
                className={cnMixSpace({ mR: 's' })}
                loading={deleteStatus === RequestStatus.FETCHING}
                disabled={deleteStatus === RequestStatus.FETCHING}
            />
            <ConfirmationDialog
                textHeader="УДАЛЕНИЕ ЗАПИСЕЙ"
                textConfirmation="Вы уверены, что хотите удалить записи?"
                isOpened={isConfirmationDialogOpen}
                onSubmit={handleDeleteExactly}
                onClose={handleOnClose}
                cancelButtonText="Не удалять"
                confirmButtonText="Удалить"
            />
            <ErrorHandlingModal
                titleText="УДАЛЕНИЕ ЗАПИСЕЙ"
                isSubmitted={isSubmitted}
                statusRequest={deleteStatus}
                dataRequest={deleteData}
                errorsRequest={deleteError}
                handleCloseModalError={handleCloseModalError}
                handleCreateReport={handleCreateReport}
            />
        </>
    );
};

WorkOrderOtherDelete.displayName = 'WorkOrderOtherDelete';
